import React from 'react'
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch
} from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'

import PrivateRoute from './Router/PrivateRoute'
import AdminOnlyRoute from './Router/AdminOnlyRoute'
import App from './App/App'
import LoginPage from './LoginPage/LoginPage'
import ActiveProjectPage from './ActiveProjectPage/ActiveProjectPage'
import TemplateListPage from './TemplateListPage/TemplateListPage'
import TemplateEditPage from './TemplateEditPage/TemplateEditPage'
import ProjectDocumentPage from './ProjectDocumentPage/ProjectDocumentPage'
import ConfigPage from './ConfigPage/ConfigPage'
import ProfilePage from './ProfilePage/ProfilePage'
import UserManagementPage from './UserManagementPage/UserManagementPage'

const history = createBrowserHistory()

const configs = ({match, ...rest}) => (
	<ConfigPage {...rest}>
		<Switch>
			<Route exact path={`${match.url}/profile`} component={ProfilePage}/>
			<AdminOnlyRoute exact path={`${match.url}/user-management`} component={UserManagementPage}/>
			<Redirect to={`${match.url}/profile`}/>
		</Switch>
	</ConfigPage>
)

const workdesks = ({ match, ...rest }) => (
	<App {...rest}>
		<Switch>
			<Route exact path={`${match.url}/proposed-project`} component={ActiveProjectPage}/>
			<Route exact path={`${match.url}/active-project`} component={ActiveProjectPage}/>
			<Route exact path={`${match.url}/template`} component={TemplateListPage}/>
			<Route exact path={`${match.url}/template/new`} component={TemplateEditPage}/>
			<Route exact path={`${match.url}/template/:templateId`} component={TemplateEditPage}/>
			<Route exact path={`${match.url}/history`} component={ActiveProjectPage}/>
			<Route exact path={`${match.url}/project/new`} component={ProjectDocumentPage}/>
			<Route exact path={`${match.url}/project/:projectId/document/new`} component={ProjectDocumentPage}/>
			<Route exact path={`${match.url}/project/:projectId/document/:documentId`} component={ProjectDocumentPage}/>
			<Route path={`${match.url}/config`} component={configs}/>
			<Redirect to={`${match.url}/active-project`}/>
		</Switch>
	</App>
)

const AppRouter = () => (
    <Router history={history}>
		<Switch>
        	<Route exact path="/" render={() => {
        		const token = localStorage.getItem('token')

        		if (token)
        			return (
        				<Redirect to="/workdesk"/>
        			)
        		else {
        			localStorage.removeItem('token')
        			return (
        				<Redirect to="/login"/>
        			)
        		}
        	}}/>
			<Route path="/login" component={LoginPage}/>
			<PrivateRoute path="/workdesk" component={workdesks}/>
        </Switch>
    </Router>
)

export default AppRouter


// WEBPACK FOOTER //
// ./src/router.js